import React, { useEffect, useState } from 'react';
import liracrypt from '../Liracrypt/liracrypt';
import { Spin, message } from 'antd';
import ApiErrorComp from '../ApiErrorComp/ApiErrorComp';
import { LoadingOutlined } from '@ant-design/icons';

const TaskLogBox = ({
    api,
    params,
    heading
}) => {
    const [loading, setLoading] = useState(true);
    const [logData, setLogData] = useState();
    useEffect(() => {
        setLoading(true);
        liracrypt.get(api, { ...params })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setLogData(data.data);
                    setLoading(false);
                } else {
                    message.error('Something went wrong');
                }
            }).catch(err => {
                ApiErrorComp();
                console.error(err);
            })
    }, []);

    return (
        <div>
            <p className='pms-card-header'>{heading}</p>
            <div className='scroller' style={{minHeight: 400, padding: 10 }}>
                {
                    loading ?
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} />} /> :
                        <>
                            {
                                logData?.length ? (
                                    logData.map((log, index) => (
                                        <div className="pms-card" key={`log-${index}`}>
                                            {
                                                log.map((x, i) => (
                                                    typeof (x.text) === 'string' ?
                                                        <p style={{ marginBottom: 4 }} className={x.class} key={i}>{x.text}</p> :
                                                        <div key={i} className={`${x.class} pms-key-val-wrapper`}>
                                                            <p className='pms-card-key'>{x.text.key} </p>
                                                            <p className='pms-card-val'>{x.text.value}</p>
                                                        </div>
                                                ))
                                            }
                                        </div>
                                    ))
                                ) : <></>
                            }
                        </>
                }
            </div>
        </div>
    )
};

export default TaskLogBox;